"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDetailsActionMenu = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
function FileDetailsActionMenu(props) {
    var archive = props.archive, unarchive = props.unarchive, download = props.download, preview = props.preview, isArchived = props.isArchived, previewDisabled = props.previewDisabled, handlePreviewEmail = props.handlePreviewEmail;
    function onDownload() {
        togglePopover();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        download();
    }
    function onPreview() {
        togglePopover();
        if (handlePreviewEmail)
            handlePreviewEmail();
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        if (!handlePreviewEmail)
            preview(true);
    }
    function onArchive() {
        togglePopover();
        archive();
    }
    function onUnarchive() {
        togglePopover();
        unarchive();
    }
    var _a = (0, core_ui_1.usePopover)({
        excludeTarget: true,
    }), popoverRef = _a.popoverRef, isPopoverOpen = _a.isPopoverOpen, togglePopover = _a.togglePopover, targetRef = _a.targetRef;
    var menuItems = [
        {
            label: 'Preview',
            onClick: onPreview,
            target: '_blank',
            isDisabled: previewDisabled,
        },
        {
            label: 'Download',
            onClick: onDownload,
        },
    ];
    if (isArchived) {
        menuItems.push({
            label: 'Unarchive',
            onClick: onUnarchive,
        });
    }
    else {
        menuItems.push({
            label: 'Archive',
            onClick: onArchive,
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: { position: 'absolute', top: '32px', right: '32px' } },
            react_1.default.createElement(core_ui_1.IconButton, { type: "more", onClick: togglePopover, elementRef: targetRef, isActive: isPopoverOpen })),
        react_1.default.createElement(core_ui_1.Portal, { name: "sheetActions" },
            react_1.default.createElement("div", { style: { zIndex: 999, position: 'relative', top: 0 } },
                react_1.default.createElement(core_ui_1.Tether, { targetRef: targetRef, targetAnchor: "bottomRight", anchor: "topRight", yOffset: 10 },
                    react_1.default.createElement(core_ui_1.PopoverAnimation, { isOpen: isPopoverOpen, direction: "up" },
                        react_1.default.createElement(core_ui_1.Box, { border: 1, borderRadius: 3, elementRef: popoverRef, boxShadow: "card", backgroundColor: "white" },
                            react_1.default.createElement(core_ui_1.Padding, { y: 8 },
                                react_1.default.createElement(core_ui_1.Menu, { items: menuItems })))))))));
}
exports.FileDetailsActionMenu = FileDetailsActionMenu;
